import ToastHighLighter from '@/lib/ToastHighLighter';

export const CookieCssCode = () => {
  const language = 'css';
  const codeString = `
  // Cookiebanner
  .cookiealert {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    margin: 0 !important;
    z-index: 999;
    opacity: 0;
    transform: translateY(100%);
    transition: all 500ms ease-in-out;
    border-top: 1px solid #3c3c3c;

    p {
      color: $white;

      a {
        color: $white;
        text-decoration: underline;

        &:hover {
          color: $white;
          opacity: 1;
        }
      }
    }

    &.show {
      opacity: 1;
      transform: translateY(0%);
      transition-delay: 1000ms;
    }
  }
`;

  return (
    <>
      <ToastHighLighter
        name={'navigationtabs'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
